import { Column, Row } from '@/components';
import { useService } from '@/containers/ActionServiceV2/context';
import React, { FunctionComponent } from 'react';
import { LazyRichTextEditor } from '@/components/RichTextEditor/LazyRichTextEditor';
import { Faqs } from '@/components/AssetFaqs/Faqs';
import { ImageGallery } from '@/components/ImageGallery';
import { ImagesManager } from '@/components/ImagesManager';

export const ContentTab: FunctionComponent = () => {
  const {
    coverImage,
    setCoverImage,
    serviceDescription,
    setServiceDescription,
    faqs,
    setFaqs,
    imageGallery,
    setImageGallery
  } = useService();
  return (
    <div className="flex flex-col gap-6 pt-4 px-2 sm:px-0 w-full sm:max-w-[672px] mx-auto">
      <div className="w-full sm:border-2 sm:border-gray-200 sm:rounded-xl sm:p-6 sm:bg-white">
        <Column className="w-full" gap={20}>
          <span className="text-xl font-medium">Descripción</span>
          <div className="w-full">
            <LazyRichTextEditor
              placeholder="Contale a tus clientes de qué trata tu servicio"
              content={serviceDescription}
              limit={5000}
              onChange={(content) => setServiceDescription(content)}
            />
          </div>
        </Column>
        <Column className="pt-8" gap={20}>
          <ImagesManager
            coverImage={coverImage}
            handleCoverImage={setCoverImage}
            preview={
              <Column gap={16}>
                <div
                  style={{
                    backgroundImage: `url(${coverImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                  className="w-[250px] h-[250px] aspect-square-1/1 shadow-[0px_4px_23px_0px_#0000001C] rounded-xl"
                >
                  <Column
                    gap={5}
                    justify="flex-end"
                    className="bg-gradient-to-t from-[#1a1a1a] rounded-xl pb-5 px-4 w-full h-full"
                  >
                    <div className="bg-white w-full h-10" />
                    <div className="bg-white w-full h-6" />
                    <Row align="center" justify="space-between">
                      <div className="bg-white w-10 h-6" />
                      <div className="bg-white w-12 h-6" />
                      <div className="bg-white w-14 h-6" />
                    </Row>
                    <Row align="center" justify="space-between">
                      <div className="bg-white w-20 h-6" />
                      <div className="bg-white w-20 h-6" />
                    </Row>
                  </Column>
                </div>
                <p className="text-[#868686] text-xs">Tarjeta informativa</p>
              </Column>
            }
          />
        </Column>
        <Column className="pt-8" gap={20}>
          <div className="w-full">
            <ImageGallery
              title={
                <Column className="mb-5">
                  <span className="text-xl font-medium">Galería de fotos</span>
                  <label className="font-normal text-xs text-[#858585]">
                    Estas son las imágenes que vas a compartir en la página del servicio. Máx 10MB (jpeg, png)
                  </label>
                </Column>
              }
              images={imageGallery}
              setImages={setImageGallery}
            />
          </div>
        </Column>
        <Column className="pt-8" gap={20}>
          <Column>
            <span className="text-xl font-medium">Preguntas frecuentes</span>
            <label className="font-normal text-xs text-[#858585] w-full md:w-[80%]">
              Nadie conoce tu negocio mejor que vos. Ayudá a tus clientes a despejar sus dudas creando una
              sección acerca de las preguntas y respuestas más frecuentes de tu servicio.
            </label>
          </Column>
          <div className="w-full md:w-[80%]">
            <Faqs faqs={faqs} setFaqs={setFaqs} />
          </div>
        </Column>
      </div>
    </div>
  );
};
